'use strict';
var ImmobiliareFlux = require('./lib/module'),
    basicComponents = require('./lib/basic-components'),
    swig = require('./lib/templating/swig-include');

ImmobiliareFlux.basicComponents = basicComponents;
ImmobiliareFlux.templating = swig;

module.exports = ImmobiliareFlux;

